//const glbFormatSepMillon = "'";
//const glbFormatSepBillon = '"';
//const glbFormatSepThousand = ".";
//const glbFormatSepDec = ",";
//const glbUnFormatSepDec = ".";
import moment from "moment";

export var misc = {
  methods: {
    singular(tag) {
      let result = '';
      if (this.notBlank(tag)) {
        result = tag;
        if (result.substring(result.length - 1, result.length) == 's') {
          result = result.substring(0, result.length - 1);
        }
      }
      return result;
    },
    emptyObject(data) {
      return data != null && Object.keys(data).length == 0;
    },
    emptyString(data) {
      return !data || data === '';
    },
    notBlank(data) {
      return !this.emptyString(data);
    },
    notZero(data) {
      return data && data > 0;
    },
    parseBoolean(value) {
      return (value === 1) || (value === true) || (value === 'true');
    },
    greatherThanZero(data) {
      return data != null && data > 0;
    },
    separators() {
      return {
        fr: {
          formatSepMillon: " ",
          formatSepBillon: ' ',
          formatSepThousand: " ",
          formatSepDec: ",",
          unFormatSepDec: ".",
          locationCurrency: "after"
        },
        en: {
          formatSepMillon: "'",
          formatSepBillon: '"',
          formatSepThousand: ",",
          formatSepDec: ".",
          unFormatSepDec: ".",
          locationCurrency: "before"
        }
      }
    },

    isNumberic(value) {
      switch (typeof value) {
        case 'string': {
          return !isNaN(value) && !isNaN(parseFloat(value))
        }
        case 'number': {
          return true;
        }
        default: {
          return false;
        }
      }
    },

    getSeparator(locale, separatorType) {
      const numberWithGroupAndDecimalSeparator = 1000.1;
      return Intl.NumberFormat(locale)
        .formatToParts(numberWithGroupAndDecimalSeparator)
        .find(part => part.type === separatorType)
        .value;
    },

    glbFormatSep(name) {
      const language = this.currentLanguage();
      return this.separators()[language][name];
    },
    glbFormatSepMillon() { return this.glbFormatSep('formatSepMillon') },
    glbFormatSepBillon() { return this.glbFormatSep('formatSepBillon') },
    glbFormatSepThousand() { return this.glbFormatSep('formatSepThousand') },
    glbFormatSepDec() { return this.glbFormatSep('formatSepDec'); },
    glbUnFormatSepDec() { return this.glbFormatSep('unFormatSepDec'); },
    glbLocationCurrency() { return this.glbFormatSep('locationCurrency') },

    formatLocaleNumber(number, int, dec) {
      const withValue = typeof number == 'number' ? number != null : this.notBlank(number);
      if (withValue) {
        const numberValue = this.isNumberic(number) ? typeof number == 'number' ? number : parseFloat(number) : 0;
        const language = this.currentLanguageEx();
        return int && dec ? numberValue.toLocaleString(language, { minimumFractionDigits: dec }) : numberValue.toLocaleString(language);
      } else {
        return null
      }
    },

    parseLocaleNumber(stringNumber) {
      const language = this.currentLanguageEx();
      var thousandSeparator = Intl.NumberFormat(language).format(11111).replace(/\p{Number}/gu, '');
      var decimalSeparator = Intl.NumberFormat(language).format(1.1).replace(/\p{Number}/gu, '');

      const result = parseFloat(stringNumber
        .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
        .replace(new RegExp('\\' + decimalSeparator), '.')).toString();

      return result;
    },

    formatReal(input, int, dec) {
      return this.formatLocaleNumber(input, int, dec);
    },

    unformattedReal(input) {
      return this.parseLocaleNumber(input);
    },

    unFormatReal(input) {
      let value = input;
      if (this.notBlank(value) && !this.unformattedReal(input)) {
        let reto = '';
        for (let f = 0; f <= value.length; f++) {
          if (value.charAt(f) == this.glbFormatSepDec()) {
            reto = reto + this.glbUnFormatSepDec();
          } else if ((value.charAt(f) != this.glbFormatSepThousand()) && (value.charAt(f) != this.glbFormatSepMillon()) && (value.charAt(f) != this.glbFormatSepBillon)) {
            reto = reto + value.charAt(f);
          }
        }
        value = reto;
      }
      return value;
    },

    formatDate(date) {
      return date ? moment(date).format("ll") : ''
    },

    formatDateTime(dateTime) {
      return dateTime ? moment(dateTime).format("lll") : ''
    },

    parseInputStructure(inputStructure) {
      const inputArray = inputStructure && typeof inputStructure == 'string'
        ? inputStructure
          .split(",")
          .map(f => {
            return f.includes(":") ? {
              source: f.split(":")[0],
              target: f.split(":")[1]
            } : {
              source: f,
              target: f
            }
          })
        : [];
      return inputArray;
    },

    combineInputStructures(inputStructures) {
      if (inputStructures && Array.isArray(inputStructures) && inputStructures.length > 0) {
        let baseStructure = this.parseInputStructure(inputStructures[0]);
        if (inputStructures.length > 1) {
          inputStructures.forEach((inputStructure, i) => {
            if (i > 0) {
              const inputStructureArray = this.parseInputStructure(inputStructure);
              inputStructureArray.forEach(isi => {
                const indexBase = baseStructure.findIndex(bs => bs.source == isi.source);
                if (indexBase >= 0) {
                  const source = baseStructure[indexBase].source;
                  let target = baseStructure[indexBase].target;
                  if (target == source && isi.target != source) {
                    target = isi.target;
                  }
                  baseStructure[indexBase].target = target;
                } else {
                  baseStructure.push(isi);
                }
              })
            }
          });
          return baseStructure;
        }
      } else {
        return [];
      }
    },

    unParseInputStructure(inputStructureArray) {
      return inputStructureArray && Array.isArray(inputStructureArray)
        ? inputStructureArray
          .map(isi => {
            return isi.source != isi.target
              ? isi.source + ':' + isi.target
              : isi.source
          })
          .join(',')
        : null;
    },

    validateUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    }
  },

}